import type { FunnelStage } from '../api/types';

export interface StagePalette {
  bg: string;
  border: string;
  text: string;
  dot: string;
}

/** Single source of truth for the pastel funnel-stage palette (§U4) — column headers, card accents, badges. */
export const STAGE_COLORS: Record<FunnelStage, StagePalette> = {
  new: { bg: 'bg-slate-50', border: 'border-slate-200', text: 'text-slate-700', dot: 'bg-slate-400' },
  first_touch: { bg: 'bg-sky-50', border: 'border-sky-200', text: 'text-sky-700', dot: 'bg-sky-400' },
  replied: { bg: 'bg-cyan-50', border: 'border-cyan-200', text: 'text-cyan-700', dot: 'bg-cyan-400' },
  qualified: { bg: 'bg-teal-50', border: 'border-teal-200', text: 'text-teal-700', dot: 'bg-teal-400' },
  meeting_requested: {
    bg: 'bg-amber-50',
    border: 'border-amber-200',
    text: 'text-amber-700',
    dot: 'bg-amber-400',
  },
  meeting_held: {
    bg: 'bg-orange-50',
    border: 'border-orange-200',
    text: 'text-orange-700',
    dot: 'bg-orange-400',
  },
  kotbot_registered: {
    bg: 'bg-violet-50',
    border: 'border-violet-200',
    text: 'text-violet-700',
    dot: 'bg-violet-400',
  },
  first_deposit: {
    bg: 'bg-fuchsia-50',
    border: 'border-fuchsia-200',
    text: 'text-fuchsia-700',
    dot: 'bg-fuchsia-400',
  },
  active: { bg: 'bg-emerald-50', border: 'border-emerald-200', text: 'text-emerald-700', dot: 'bg-emerald-400' },
  lost: { bg: 'bg-rose-50', border: 'border-rose-200', text: 'text-rose-700', dot: 'bg-rose-400' },
};

export function stagePalette(stage: string): StagePalette {
  return STAGE_COLORS[stage as FunnelStage] ?? STAGE_COLORS.new;
}
